module.exports = __webpack_public_path__ + "static/lady-with-bag-b3ddcf6f5c1b2b8594fb38d7535095c8.jpg";